import classNames from 'classnames';
import { type FC, type RefObject, useContext, useRef, useState } from 'react';
import { ChevronIcon } from 'src/components/shared/elements/icons/ChevronIcon';
import { type ShopSchema } from 'src/models/shop/schema';
import { I18nContext } from 'src/stores/I18n';
import { type ShopModalMode } from './type';

type Props = {
  shopsData: {
    map: Map<string, ShopSchema[]>;
    prefectures: string[];
  };
  setMode: (mode: ShopModalMode) => void;
  setSelectedShop: (shop: ShopSchema | undefined) => void;
  containerRef: RefObject<HTMLDivElement>;
};

export const ListContent: FC<Props> = ({ shopsData, setMode, setSelectedShop, containerRef }) => {
  const localeResources = useContext(I18nContext);
  const titlesRef = useRef(new Map<string, HTMLDivElement | null>());
  const [activePrefecture, setActivePrefecture] = useState('');

  return (
    <div
      className="flex flex-col gap-10 pb-10 px-5 w-screen max-h-[80vh] overflow-y-auto hidden-scrollbar max-w-[440px]"
      ref={containerRef}
    >
      <div className="flex flex-col gap-5">
        <div className="text-sm">{localeResources.receive.list.popularRegions}</div>
        <div className="flex gap-2.5 flex-wrap">
          {shopsData.prefectures.map((prefecture) => (
            <div
              className={classNames(
                'border border-solid border-black text-black rounded-full px-5 py-2 text-sm cursor-pointer',
                {
                  'text-primary border-primary': prefecture === activePrefecture
                },
                'hover:bg-gray100 hover:border-black hover:text-black'
              )}
              onClick={() => {
                setActivePrefecture(prefecture);
                titlesRef.current.get(prefecture)?.scrollIntoView({ behavior: 'smooth' });
              }}
              key={prefecture}
            >
              {prefecture}
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col">
        <div className="leading-6 text-sm flex gap-1">
          {localeResources.receive.list.pickupLocation}
          <span className="text-primary text-xl leading-5">※</span>
        </div>
        {shopsData.prefectures.map((prefecture) => {
          const currentShops = shopsData.map.get(prefecture);
          if (!currentShops) return null;
          return (
            <div key={prefecture}>
              <div
                className="border-b border-solid border-black font-medium p-2.5"
                ref={(el) => titlesRef.current.set(prefecture, el)}
              >{`${prefecture}（${currentShops.length}）`}</div>
              {currentShops.map((shop) => (
                <div
                  className="flex justify-between items-center p-2.5"
                  onClick={() => {
                    setMode('detail');
                    setSelectedShop(shop);
                  }}
                  key={shop.name}
                >
                  <div>{shop.name}</div>
                  <ChevronIcon />
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};
